import React, { useState } from 'react';
import { Container, Button, Spinner, Alert } from 'react-bootstrap';
import AdminLayout from '../components/layout/AdminLayout';
import { useProductos } from '../hooks/useProductos';
import { useImageUpload } from '../hooks/useImageUpload';
import ProductosList from '../components/productos/ProductosList';
import ProductoModal from '../components/productos/ProductoModal';
import DeleteConfirm from '../components/productos/DeleteConfirm';

const ProductosPage = () => {
  const { productos, loading, error, createProducto, updateProducto, deleteProducto } = useProductos();
  const { deleteImage, extractPathFromUrl } = useImageUpload('productos-lumiere');

  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedProducto, setSelectedProducto] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);

  const handleCreate = () => {
    setSelectedProducto(null);
    setShowModal(true);
  };

  const handleEdit = (producto) => {
    setSelectedProducto(producto);
    setShowModal(true);
  };

  const handleDeleteClick = (producto) => {
    setSelectedProducto(producto);
    setShowDeleteConfirm(true);
  };

  const handleSaveProducto = async (data) => {
    // Extraer el ID si existe y crear una copia limpia de los datos
    const { id, ...cleanData } = data;
    
    if (selectedProducto) {
      await updateProducto(selectedProducto.id, cleanData);
    } else {
      await createProducto(cleanData);
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedProducto) return;
    try {
      setActionLoading(true);

      // Guardamos la referencia de la imagen antes de borrar el producto
      const oldImageUrl = selectedProducto.imagen;

      await deleteProducto(selectedProducto.id);

      // Si el producto tenía imagen, la borramos del storage
      if (oldImageUrl) {
        const pathToDelete = extractPathFromUrl(oldImageUrl);
        if (pathToDelete) {
          try {
            await deleteImage(pathToDelete);
          } catch (delErr) {
            console.error('Error deleting image from storage during product deletion:', delErr);
          }
        }
      }

      setShowDeleteConfirm(false);
    } catch (err) {
      console.error(err);
      alert('Error al eliminar el producto');
    } finally {
      setActionLoading(false);
    }
  };

  return (
    <AdminLayout>
      <Container fluid className="py-4">


        <div className="admin-card">
          {error && <Alert variant="danger">{error}</Alert>}

          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="warning" />
              <p className="mt-2 text-muted mb-0">Cargando catálogo...</p>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 style={{ color: '#2A2F35' }} className="m-0 fw-bold">
                  <i className="fas fa-box me-3"></i>
                  Gestión de Productos
                </h2>
                <Button
                  onClick={handleCreate}
                  style={{ backgroundColor: '#c4956a', borderColor: '#c4956a' }}
                  className="fw-semibold"
                >
                  <i className="fas fa-plus me-2"></i>Nuevo Producto
                </Button>
              </div>
              <ProductosList
                productos={productos}
                onEdit={handleEdit}
                onDelete={handleDeleteClick}
              />
            </>
          )}
        </div>

        {/* Modales de Crear/Editar y Eliminación */}
        <ProductoModal
          show={showModal}
          onHide={() => setShowModal(false)}
          onSave={handleSaveProducto}
          productoEdit={selectedProducto}
        />

        <DeleteConfirm
          show={showDeleteConfirm}
          onHide={() => setShowDeleteConfirm(false)}
          onConfirm={handleConfirmDelete}
          productoNombre={selectedProducto?.nombre || ''}
          loading={actionLoading}
        />
      </Container>
    </AdminLayout>
  );
};

export default ProductosPage;